import { sample } from 'lodash-es'

import type { WorkspaceRole } from '@/data/roles'
import { api } from '@/api'
import { defaultTeamColors } from '@/utils/colors'
import type { AccountUser, WorkspaceUser } from './types'

export const getUserCount = async () => {
  const { count } = await api.get('users/count').json<{ count: string }>()
  return parseInt(count, 10)
}

export const createWorkspace = async (name: string, addAllConnections: boolean) => {
  const workspace = { name, color: sample(defaultTeamColors), addAllConnections }
  const { id } = await api.post('workspaces', { json: workspace }).json<{ id: string }>()
  return { ...workspace, id: parseInt(id) }
}

export const getAccountUsers = () => api.get('users').json<{ readonly: boolean; users: AccountUser[] }>()

export const getAccountUsersCSV = () => api.get('users.csv').json<string>()

export const getWorkspaceUsers = (workspaceId: number) =>
  api
    .get('users', { headers: { 'X-Klaus-Workspace': workspaceId.toString() } })
    .json<{ readonly: boolean; users: WorkspaceUser[] }>()

interface BulkUpdateUserPayload {
  workspaceId?: number
  userIds: string[]
  workspacesToAdd?: number[]
  workspacesToRemove?: number[]
  groupsToAdd?: string[]
  groupsToRemove?: string[]
}

interface BulkUpdateWorkspaceMembershipPayload {
  workspaceId: number
  userIds: string[]
  action: 'add' | 'remove'
  workspaceRoles?: { userId: string; role: WorkspaceRole }[]
}

export const bulkUpdateUser = (json: BulkUpdateUserPayload) => api.put('users', { json }).json<any>()

export const bulkUpdateWorkspaceMembership = ({
  workspaceId,
  userIds,
  action,
  workspaceRoles,
}: BulkUpdateWorkspaceMembershipPayload) =>
  api
    .put('users', {
      headers: { 'X-Klaus-Workspace': workspaceId.toString() },
      json: { userIds, [action === 'add' ? 'workspacesToAdd' : 'workspacesToRemove']: [workspaceId], workspaceRoles },
    })
    .json<any>()

export const getUsersNotInWorkspace = async (workspaceId: number) => {
  const { users } = await api
    .get('users/not-in-workspace', { headers: { 'X-Klaus-Workspace': workspaceId.toString() } })
    .json<{ users: WorkspaceUser[] }>()
  return users.sort((a, b) => a.name.localeCompare(b.name))
}

export const setUserAsBot = (userId: string, reviewable: boolean) =>
  api.post(`users/${userId}/set-as-bot`, { json: { reviewable } }).json()
